import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { LeadTableComponent } from '../../../../crm/lead/view/table';
import { CampanhaLeadFilter } from '../filter';

@Component({
    selector: 'sgt-campanha-lead-view',
    templateUrl: './campanha-lead-view.component.html',
    styleUrls: ['./campanha-lead-view.component.less']
})
export class CampanhaLeadViewComponent implements OnDestroy {
    @Input() idCampanha: number;

    filter = new CampanhaLeadFilter();
    @ViewChild('leadTable') leadTable: LeadTableComponent;

    /** Ao alterar o filtro */
    onFilterChange() {
        this.search();
    }

    /** Pesquisa os leads */
    search() {
        if (!this.idCampanha) {
            return
        }
        setTimeout(() => this.leadTable?.search(), 0);
    }

    ngOnDestroy(): void {
        this.filter = null;
    }
}
